// Toggle FAQ accordion items
function toggleFaqAccordion(id) {
  var answer = document.getElementById('faq' + id + '-ans'),
    arrow = document.getElementById('faq' + id + '-arrow');

  if (answer) {
    if (answer.getAttribute('data-bs-toggled') === 'false') {
      // Show

      // First make sure all other answers are being closed
      var answers = document.getElementsByClassName('faq-answer');

      for (var i = 0; i < answers.length; i++) {
        if (!answers[i].classList.contains('faq-answer-closed')) {
          answers[i].classList.add('faq-answer-closed');
          answers[i].setAttribute('data-bs-toggled', 'false');
          document.getElementById(
            'faq' + answers[i].getAttribute('data-id') + '-arrow'
          ).style.transform = 'rotate(0deg)';
        }
      }

      // Update styling
      answer.setAttribute('data-bs-toggled', 'true');
      answer.classList.remove('faq-answer-closed');
      arrow.style.transform = 'rotate(180deg)';
    } else {
      // Hide
      answer.setAttribute('data-bs-toggled', 'false');
      answer.classList.add('faq-answer-closed');
      arrow.style.transform = 'rotate(0deg)';
    }
  }
}

export { toggleFaqAccordion };
